(function handleSelectedletter() {
    let checkBox = document.querySelector('input[name="tag-letter-xsell"]');
    checkBox.addEventListener('change', function () {
        if (checkBox.checked) {
            document.querySelector('.xsell-letter-wrapper').classList.add('open');
            handleBagLetterChange();
        } else {
            document.querySelector('.xsell-letter-wrapper').classList.remove('open');
            window._xbage_letter_variant = null;
        }
    })


    let colorSwatches = document.querySelectorAll('input[name="xsell-color"]');
    colorSwatches.forEach((swatch) => {
        swatch.addEventListener('change', function () {
            handleBagLetterChange();
            checkLettersAvailability();
        });
    });

    let letterSwatches = document.querySelectorAll('.xsell-letter-content .Popover__Value')
    letterSwatches.forEach((btn) => {
        btn.addEventListener('click', function () {
            setTimeout(handleBagLetterChange, 100);
        });
    });
    function handleBagLetterChange() {
        let product_handle = document.querySelector('input[name="xsell-color"]:checked').value;
        let selected_letter = document.querySelector('.xsell-letter-content .Popover__Value.is-selected').dataset.value;
        console.log('product_handle ', product_handle, 'selected_letter ', selected_letter);
        let selected_product = _xbags_products.filter((p) => { return p.handle == product_handle; });
        if (selected_product.length > 0) {
            console.log("selected_product", selected_product);
            let selected_variant = selected_product[0].variants.filter((v) => { return v.option1 == selected_letter; });
            if (selected_variant.length > 0) {
                console.log(" selected_variant ", selected_variant);
                let featured_image = selected_variant[0].featured_image.src ? selected_variant[0].featured_image.src : selected_product[0].featured_image;
                document.querySelector('.xsell-letter-content img').setAttribute('srcset', featured_image.replace('.jpg', '_105x.jpg'));
                window._xbage_letter_variant = selected_variant[0].id;
                document.querySelector('.xsell-letter-wrapper .money').innerText = __WEBPACK_IMPORTED_MODULE_4__helper_Currency__["default"].formatMoney(selected_variant[0].price, window.theme.moneyFormat)
            }
        }
    }

    function checkLettersAvailability() {
        let product_handle = document.querySelector('input[name="xsell-color"]:checked').value;
        let selected_product = _xbags_products.filter((p) => { return p.handle == product_handle; });
        selected_product[0].variants.forEach((v, index) => {
            if (v.available) {
                console.log(' true ', v)
                if (document.querySelector('.xsell-letter-content .Popover__ValueList .Popover__Value:nth-child(' + (index + 1) + ')')) {
                    document.querySelector('.xsell-letter-content .Popover__ValueList .Popover__Value:nth-child(' + (index + 1) + ')').removeAttribute('disabled');
                }
            } else {
                console.log(' false ', v)
                if (document.querySelector('.xsell-letter-content .Popover__ValueList .Popover__Value:nth-child(' + (index + 1) + ')')) {
                    document.querySelector('.xsell-letter-content .Popover__ValueList .Popover__Value:nth-child(' + (index + 1) + ')').setAttribute('disabled', true);
                }
            }
        })

    }

})();